<template>
<pop-up-layout 
  :title="$t('reservaSimplificada.enviarReserva')"
  :description="$t('reservaSimplificada.enviarReservaMessage')"
  :ocultarVolver="true"
>
  <v-layout column justify-center align-center>
    <v-img v-if="!yaEnviada"
                style="margin-bottom: 30px; width:180px;" 
                :src="require('@/assets/images/WARNING_GRIS.png')"
              />
              <o-description-title v-if="!yaEnviada">
                {{$t('general.popUpSeguro.alertaIrreversible')}}
              </o-description-title>
    <o-description-title v-if="errorSincronizacion" colorClass="error--text">{{errorSincronizacion}}</o-description-title>
    <v-layout wrap justify-center align-center slot="acciones">

      <v-btn 
        color="primary" 
        @click="$parent.hide()"
        :disabled="saving || loading"
        :loading="saving || loading"
        v-if="!errorSincronizacion"
      >
{{$t('general.popUpSeguro.cancelar')}}
      </v-btn>
      <v-btn 
        color="primary" 
        @click="enviarRE()"
        :disabled="saving || loading"
        :loading="saving || loading"
      >

     {{!yaEnviada ? $t('reservaSimplificada.enviar') : $t('reservas.contrato.aceptar')}}
      </v-btn>
    </v-layout>
  </v-layout>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    textoBoton: {
      default () {
        return 
      }
    },
    
  },
  data () {
    return {
      yaEnviada: false,
      errorSincronizacion: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    }),
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      error: false,
      enviarReservaBack: 'reservas/_id/enviarReserva',
    }),
    async cerrarPopup () {
      this.$emit('hide')
    },
    async enviarRE () {
      try {
        this.loading = true
        if (this.yaEnviada) {
          this.$router.push({name: 'reservas.list'})
          return false
        }
        await this.enviarReservaBack(this.reserva.id)
        if (this.reserva.sincronizada) {
          this.addAlert({texto: this.$t('reservaSimplificada.enviadaExito'), color: 'success'})
          this.$router.push({name: 'reservas.list'})
          return false

        } else {
          this.errorSincronizacion = this.$t('reservas.listas.sincronizadaError')
        }
        this.yaEnviada = true
        this.loading = false
      } catch (error) {
          this.yaEnviada = true
          this.loading = false
          this.errorSincronizacion = this.$t('reservas.listas.sincronizadaError')
          if (!error.code || error.code !== 1) {
            this.addAlert({texto: error.message, color: 'error'})
          }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generic/PopUpEnviarRE.vue